"use client"

import { useState } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import LobbyScreen from "./components/LobbyScreen"
import GameScreen from "./components/GameScreen"
import "./App.css"

function App() {
    const [playerName, setPlayerName] = useState("")
    const [playerId, setPlayerId] = useState("")

    return (
        <Router>
            <div className="app">
                <h1 className="title">Pac-Man</h1>
                <Routes>
                    <Route
                        path="/"
                        element={<LobbyScreen playerName={playerName} setPlayerName={setPlayerName} setPlayerId={setPlayerId} />}
                    />
                    <Route path="/game/:roomId" element={<GameScreen playerName={playerName} playerId={playerId} />} />
                </Routes>
            </div>
        </Router>
    )
}

export default App

